/* eslint-disable no-template-curly-in-string */

import { TClient } from '@frontend/applications/PaymentsApp/types';
import { TProject } from '../../types';

export const getDefaultTermsEmailTemplate = (program: TProject, client: TClient) => {
  return {
    title: `Brief Template for ${program.title}`,
    subject: `${client.name} | Brief for ${program.title}`,
    text: JSON.stringify({
    blocks: [
      {
        key: 'fe0b3',
        text: 'Hi First Name,',
        type: 'unstyled',
        depth: 0,
        inlineStyleRanges: [

        ],
        entityRanges: [
          {
            offset: 3,
            length: 10,
            key: 0,
          },
        ],
        data: {

        },
      },
      {
        key: '9h4f2',
        text: '',
        type: 'unstyled',
        depth: 0,
        inlineStyleRanges: [

        ],
        entityRanges: [

        ],
        data: {

        },
      },
      {
        key: 'dmm5t',
        text: 'I am excited to work with you on this collaboration! Since I\'m using Aspire',
        type: 'unstyled',
        depth: 0,
        inlineStyleRanges: [

        ],
        entityRanges: [

        ],
        data: {

        },
      },
      {
        key: '83g1o',
        text: 'to help manage this program, you\'ll need to click the link below to see the',
        type: 'unstyled',
        depth: 0,
        inlineStyleRanges: [

        ],
        entityRanges: [

        ],
        data: {

        },
      },
      {
        key: 'acdan',
        text: 'details and accept the brief. I look forward to working with you.',
        type: 'unstyled',
        depth: 0,
        inlineStyleRanges: [

        ],
        entityRanges: [

        ],
        data: {

        },
      },
      {
        key: '7j25j',
        text: '',
        type: 'unstyled',
        depth: 0,
        inlineStyleRanges: [

        ],
        entityRanges: [

        ],
        data: {

        },
      },
      {
        key: '9gdat',
        text: 'Link To Brief',
        type: 'unstyled',
        depth: 0,
        inlineStyleRanges: [

        ],
        entityRanges: [
          {
            offset: 0,
            length: 13,
            key: 1,
          },
        ],
        data: {

        },
      },
      {
        key: '4u785',
        text: '',
        type: 'unstyled',
        depth: 0,
        inlineStyleRanges: [

        ],
        entityRanges: [

        ],
        data: {

        },
      },
      {
        key: '5fa88',
        text: 'Best,',
        type: 'unstyled',
        depth: 0,
        inlineStyleRanges: [

        ],
        entityRanges: [

        ],
        data: {

        },
      },
      {
        key: '37h2h',
        text: 'User Name',
        type: 'unstyled',
        depth: 0,
        inlineStyleRanges: [

        ],
        entityRanges: [
          {
            offset: 0,
            length: 9,
            key: 2,
          },
        ],
        data: {

        },
      },
    ],
    entityMap: {
      0: {
        type: 'variable',
        mutability: 'IMMUTABLE',
        data: {
          data: {
            field: 'MEMBER_FIELDS.${id}',
          },
        },
      },
      1: {
        type: 'variable',
        mutability: 'IMMUTABLE',
        data: {
          data: {
            field: 'LINK_TO_TERMS',
          },
        },
      },
      2: {
        type: 'variable',
        mutability: 'IMMUTABLE',
        data: {
          data: {
            field: 'USER_NAME',
            },
          },
        },
      },
    }),
  };
};
